import { Box, Typography } from "@mui/material";
import { Diet } from "../diet/Diet";
import { Clients } from "../home/clients/Clients";
import { Meals } from "../meal/Meals";
import { useTranslation } from "react-i18next";

export function TrainerDashboard() {

    const { t } = useTranslation()

    return (
        <Box p={5} style={{ background: '#F3EEE8', borderRadius: 10 }} sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <Typography p={5} variant="h3">{t('trainerDashboard_clients')}</Typography>
            <Clients />
            <Typography p={5} variant="h3">{t('trainerDashboard_meals')}</Typography>
            <Meals />
        </Box>)
}
